<template>
    <section class="docmain-section">
        <div class="container">
            <div class="row">
                <div class="col-xl-9 col-lg-8">
                    <div class="docmain-container">
                        <div class="getting-details">
                            <p>{{ $t("home.header.Gmail") }}</p><img src="/img/up-arrow.7f2fb856.svg" alt="logo" class="right-arrow"><a
                                href="#">{{ $t('Advance.Channels.Email.Gmail.AppPassword.tittle') }}</a>
                        </div>
                      
                        <div class="Introduction-details text-align-left">
                            <h1>{{ $t('Advance.Channels.Email.Gmail.AppPassword.generate') }}</h1>
                        </div>
                        <div class="channels-info break-word code-info">
                            <div class="channels-title channels-anchor">
                                <blockquote>
                                    <p><strong>{{ $t('Advance.Channels.Email.Gmail.AppPassword.note') }}</strong> {{ $t('Advance.Channels.Email.Gmail.AppPassword.verification') }}</p>
                                </blockquote>
                                <p><strong>{{ $t('Advance.Channels.Email.Gmail.AppPassword.step1') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AppPassword.goTo') }} <a href="https://myaccount.google.com/security"
                                        target="_blank" rel="noopener noreferrer">{{ $t('Advance.Channels.Email.Gmail.AppPassword.googleAccount') }}</a></p>
                                <p><img alt="gmail_account_security"
                                        src="../../../../../../assets/images/gmail_account_securityapp.png" class="max-img">
                                </p>
                                <p><strong>{{ $t('Advance.Channels.Email.Gmail.AppPassword.step2') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AppPassword.appPassword') }}</p>
                                <p><img alt="sign_in_google" src="../../../../../../assets/images/sign_in_google.png"
                                        class="max-img"></p>
                                <p><strong>{{ $t('Advance.Channels.Email.Gmail.AppPassword.step3') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AppPassword.mailApp') }}</p>
                                <p><img alt="generate_password" src="../../../../../../assets/images/generate_password.png"
                                        class="max-img"></p>
                            </div>
                        </div>
                        <div class="edit-update-detail">
                            <!-- <div class="edit-pen">
                                <svg fill="currentColor" height="20" width="20" viewBox="0 0 40 40" class="iconEdit_dcUD"
                                    aria-hidden="true">
                                    <g>
                                        <path
                                            d="m34.5 11.7l-3 3.1-6.3-6.3 3.1-3q0.5-0.5 1.2-0.5t1.1 0.5l3.9 3.9q0.5 0.4 0.5 1.1t-0.5 1.2z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z">
                                        </path>
                                    </g>
                                </svg>
                                <a href="#">{{ $t('Advance.Channels.Email.Gmail.AppPassword.editPage') }}</a>
                            </div> -->
                            <p>{{ $t('Advance.Channels.Email.Gmail.AppPassword.lastUpdatedOn') }} <span class="dark"> {{ $t('Advance.Channels.Email.Gmail.AppPassword.date') }} </span> {{ $t('Advance.Channels.Email.Gmail.AppPassword.by') }} <span class="dark"> {{ $t('Advance.Channels.Email.Gmail.AppPassword.hrichaShandily') }}
                                </span></p>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p class="preview">{{ $t('Advance.Channels.Email.Gmail.AppPassword.previous') }}</p>


                                    <router-link to="/docs/product/channels/email/gmail/less-secure-access"
                                        class="introduction-account">
                                        <span>{{ $t('Advance.Channels.Email.Gmail.AppPassword.side') }}</span> {{ $t('Advance.Channels.Email.Gmail.AppPassword.imap') }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p>{{ $t('Advance.Channels.Email.Gmail.AppPassword.next') }}</p>


                                    <router-link to="/docs/product/channels/email/gmail/add-forward-email">
                                        {{ $t('Advance.Channels.Email.Gmail.AppPassword.forwardingAddress') }} <span>{{ $t('Advance.Channels.Email.Gmail.AppPassword.arrow') }}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import SideBar from "@/components/SideBar.vue";
import MainContent from "@/components/MainContent.vue";

export default {
    name: 'generate-app-password',
    data() {
        return {
            isToggle: false
        }
    },
    components: {
        Header,
        Footer,
        SideBar,
        MainContent
    },
    methods: {
        handleToggle() {
            this.isToggle = !this.isToggle
        }
    },
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
}
</style>
